import produce from "immer";
import {
  FETCH_LOCATIONS,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_LOCATION,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_FAILURE,
  //
  EDIT_LOCATION,
  EDIT_LOCATION_SUCCESS,
  EDIT_LOCATION_FAILURE,
  //
  DELETE_LOCATION,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_FAILURE,
  //
  SEARCH_LOCATION,
  SEARCH_LOCATION_FAILURE,
  SEARCH_LOCATION_SUCCESS,
  //
  OPEN_WEBSITE_MODAL,
  CLOSE_WEBSITE_MODAL,
  //
  OPEN_ROOM_ADD_MODAL,
  CLOSE_ROOM_ADD_MODAL,
  //
  ADD_ROOM,
  ADD_ROOM_FAILURE,
  ADD_ROOM_SUCCESS,
  //
  FETCH_ROOMS,
  FETCH_ROOMS_FAILURE,
  FETCH_ROOMS_SUCCESS,
  //
  FETCH_ALL_LOCATION,
  FETCH_ALL_LOCATION_SUCCESS,
  FETCH_ALL_LOCATION_FAILURE,
  //
  OPEN_VIEW_ROOMS_MODAL,
  CLOSE_VIEW_ROOMS_MODAL,
  //
  FETCH_ALL_ROOMS,
  FETCH_ALL_ROOMS_SUCCESS,
  FETCH_ALL_ROOMS_FAILURE,
  //
  DELETE_CARE_ROOM,
  DELETE_CARE_ROOM_SUCCESS,
  DELETE_CARE_ROOM_FAILURE,
  //
  GET_CARE_ROOM_DATA,
  GET_CARE_ROOM_DATA_SUCCESS,
  GET_CARE_ROOM_DATA_FAILURE,
  //
  EDIT_CARE_ROOM,
  EDIT_CARE_ROOM_SUCCESS,
  EDIT_CARE_ROOM_FAILURE,
  //
  OPEN_INVITE_MODAL,
  CLOSE_INVITE_MODAL,
  //
  INVITE_STAFF,
  INVITE_STAFF_SUCCESS,
  INVITE_STAFF_FAILURE,
  //
  PROFILE_STEP_EDIT,
  PROFILE_STEP_EDIT_SUCCESS,
  PROFILE_STEP_EDIT_FAILURE,
  //
  TOGGLE_INVITE_REV,
  //
  INVITE_REVIEW,
  INVITE_REVIEW_SUCCESS,
  INVITE_REVIEW_FAILURE,
  //
  GENERATE_CARD,
  GENERATE_CARD_SUCCESS,
  GENERATE_CARD_FAILURE,
  SET_CARD_LIST,
  //
  SET_ACTIVE_LOCATION,
  SET_ACTIVE_SURVEY,
  SET_USER_LOCATIONS,
  SET_ACTIVE_PATH,
  //
  FETCH_INVITEES,
  FETCH_INVITEES_SUCCESS,
  FETCH_INVITEES_FAILURE,
  //
  EXPORT_REVIEWS,
  EXPORT_REVIEWS_SUCCESS,
  EXPORT_REVIEWS_FAILURE,
  //
  SET_USER_PATH,
  //
  TOGGLE_TEAM_MODAL,
  //
  DELETE_TEAM,
  DELETE_TEAM_SUCCESS,
  DELETE_TEAM_FAILURE,
  //
  TOGGLE_SORT_MODAL,
  //
  UPDATE_SEQ,
  UPDATE_SEQ_SUCCESS,
  UPDATE_SEQ_FAILURE,
  //
  GET_FEES,
  GET_FEES_SUCCESS,
  GET_FEES_FAILURE,
  //
  UPDATE_FEE,
  UPDATE_FEE_SUCCESS,
  UPDATE_FEE_FAILURE,
  //
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
  //
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  //
  DELETE_VIDEO,
  DELETE_VIDEO_SUCCESS,
  DELETE_VIDEO_FAILURE,
  //
  GET_BACK_VIEW,
  GET_BACK_VIEW_SUCCESS,
  GET_BACK_VIEW_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingLocations: false,
  SlickCareProfiles: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentSlickCareProfiles: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  //
  websiteModalOpen: false,
  websiteModalData: {},
  //
  isRoomAddModalOpen: false,
  isFetchingRooms: false,
  Rooms: [],
  //
  fetchingAllLocation: false,
  allLocations: [],
  //
  isViewRoomsModalOpen: false,
  //
  isFetchingAllRooms: false,
  isDeletingCareRoom: false,
  isFetchingCareRoom: false,
  isEditingCareRoom: false,
  allRooms: [],
  currentCareRoom: {},
  isInviteModalOpen: {
    location_id: "",
    open: false,
  },
  isInvitingStaff: false,
  isUpdatingStep: false,
  inviteRevModal: { open: false },
  isInvitingReview: false,
  isGenerating: false,
  activeLocation: {},
  activeSurvey: {},
  userLocations: [],
  isFetchingInvitees: false,
  inviteesList: [],
  activePath: null,
  cardList: [],
  isExporting: false,
  cardPDF: null,
  posterPDF: null,
  userActivePath: "admin",
  //
  teamModal: {
    open: false,
  },
  //
  isDeletingTeam: false,
  sortModal: { open: false },
  //
  isUpdatingSeq: false,
  isFetchingFees: false,
  feeList: [],
  //
  isUpdatingFee: false,
  //
  isFetchingProfile: false,
  profileList: [],
  //
  isDeletingFile: false,
  //
  isDeletingVideo: false,
  //
  isFetchingBackCard: false,
};

const SlickCareProfilesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_LOCATIONS:
        draft.isFetchingLocations = true;
        draft.currentSlickCareProfiles = {};
        break;
      case FETCH_LOCATIONS_SUCCESS:
        draft.isFetchingLocations = false;
        draft.SlickCareProfiles = action.payload;
        break;
      case FETCH_LOCATIONS_FAILURE:
        draft.isFetchingLocations = false;
        break;
      // Search List
      case SEARCH_LOCATION:
        draft.isFetchingLocations = true;
        draft.currentSlickCareProfiles = {};
        break;
      case SEARCH_LOCATION_SUCCESS:
        draft.isFetchingLocations = false;
        draft.SlickCareProfiles = action.payload;
        break;
      case SEARCH_LOCATION_FAILURE:
        draft.isFetchingLocations = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentSlickCareProfiles = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentSlickCareProfiles = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_LOCATION:
        draft.isSubmitting = true;
        break;
      case ADD_LOCATION_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_LOCATION_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_LOCATION:
        draft.isSubmitting = true;
        break;
      case EDIT_LOCATION_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_LOCATION_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_LOCATION:
        draft.isDeleting = true;
        break;
      case DELETE_LOCATION_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_LOCATION_FAILURE:
        draft.isDeleting = false;
        break;

      case OPEN_WEBSITE_MODAL:
        draft.websiteModalOpen = true;
        draft.websiteModalData = action.payload;
        break;
      case CLOSE_WEBSITE_MODAL:
        draft.websiteModalOpen = false;
        draft.websiteModalData = {};
        break;
      // NOTE OPEN
      case OPEN_ROOM_ADD_MODAL:
        draft.isRoomAddModalOpen = true;
        break;
      case CLOSE_ROOM_ADD_MODAL:
        draft.isRoomAddModalOpen = false;
        break;
      // Add
      case ADD_ROOM:
        draft.isSubmitting = true;
        break;
      case ADD_ROOM_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_ROOM_FAILURE:
        draft.isSubmitting = false;
        break;
      // List
      case FETCH_ROOMS:
        draft.isFetchingRooms = true;
        break;
      case FETCH_ROOMS_SUCCESS:
        draft.isFetchingRooms = false;
        draft.Rooms = action.payload;
        break;
      case FETCH_ROOMS_FAILURE:
        draft.isFetchingRooms = false;
        break;

      case FETCH_ALL_LOCATION:
        draft.fetchingAllLocation = true;
        draft.allLocations = [];
        break;
      case FETCH_ALL_LOCATION_SUCCESS:
        draft.fetchingAllLocation = false;
        draft.allLocations = action.payload;
        break;
      case FETCH_ALL_LOCATION_FAILURE:
        draft.fetchingAllLocation = false;
        draft.allLocations = [];
        break;

      case OPEN_VIEW_ROOMS_MODAL:
        draft.isViewRoomsModalOpen = true;
        break;
      case CLOSE_VIEW_ROOMS_MODAL:
        draft.isViewRoomsModalOpen = false;
        break;

      case FETCH_ALL_ROOMS:
        draft.isFetchingAllRooms = true;
        draft.allRooms = [];
        break;
      case FETCH_ALL_ROOMS_SUCCESS:
        draft.isFetchingAllRooms = false;
        draft.allRooms = action.payload;
        break;
      case FETCH_ALL_ROOMS_FAILURE:
        draft.isFetchingAllRooms = false;
        draft.allRooms = [];
        break;

      case DELETE_CARE_ROOM:
        draft.isDeletingCareRoom = true;
        break;
      case DELETE_CARE_ROOM_SUCCESS:
        draft.isDeletingCareRoom = false;
        break;
      case DELETE_CARE_ROOM_FAILURE:
        draft.isDeletingCareRoom = false;
        break;

      case GET_CARE_ROOM_DATA:
        draft.isFetchingCareRoom = true;
        draft.currentCareRoom = {};
        break;
      case GET_CARE_ROOM_DATA_SUCCESS:
        draft.isFetchingCareRoom = false;
        draft.currentCareRoom = action.payload;
        break;
      case GET_CARE_ROOM_DATA_FAILURE:
        draft.isFetchingCareRoom = false;
        draft.currentCareRoom = {};
        break;

      case EDIT_CARE_ROOM:
        draft.isEditingCareRoom = true;
        break;
      case EDIT_CARE_ROOM_SUCCESS:
        draft.isEditingCareRoom = false;
        break;
      case EDIT_CARE_ROOM_FAILURE:
        draft.isEditingCareRoom = false;
        break;

      case OPEN_INVITE_MODAL:
        draft.isInviteModalOpen = action.payload;
        break;
      case CLOSE_INVITE_MODAL:
        draft.isInviteModalOpen = action.payload;
        break;

      case INVITE_STAFF:
        draft.isInvitingStaff = true;
        break;
      case INVITE_STAFF_SUCCESS:
        draft.isInvitingStaff = false;
        draft.isInviteModalOpen = { open: false, location_id: "" };
        break;
      case INVITE_STAFF_FAILURE:
        draft.isInvitingStaff = false;
        break;

      case PROFILE_STEP_EDIT:
        draft.isUpdatingStep = true;
        break;
      case PROFILE_STEP_EDIT_SUCCESS:
        draft.isUpdatingStep = false;
        break;
      case PROFILE_STEP_EDIT_FAILURE:
        draft.isUpdatingStep = false;
        break;

      case TOGGLE_INVITE_REV:
        draft.inviteRevModal = action.payload;
        break;

      case INVITE_REVIEW:
        draft.isInvitingReview = true;
        break;
      case INVITE_REVIEW_SUCCESS:
        draft.isInvitingReview = false;
        draft.inviteRevModal = { open: false, location_id: "" };
        break;
      case INVITE_REVIEW_FAILURE:
        draft.isInvitingReview = false;
        break;

      case GENERATE_CARD:
        draft.isGenerating = true;
        draft.posterPDF = null;
        break;
      case GENERATE_CARD_SUCCESS:
        draft.isGenerating = false;
        draft.cardPDF = action.payload?.cardPDF ?? null;
        draft.posterPDF = action.payload?.posterPDF ?? null;
        break;
      case GENERATE_CARD_FAILURE:
        draft.isGenerating = false;
        break;
      case SET_CARD_LIST:
        draft.cardList = action.payload;
        break;

      case SET_ACTIVE_LOCATION:
        draft.activeLocation = action.payload;
        break;
      case SET_ACTIVE_SURVEY:
        draft.activeSurvey = action.payload;
        break;
      case SET_USER_LOCATIONS:
        draft.userLocations = action.payload;
        break;
      case SET_ACTIVE_PATH:
        draft.activePath = action.payload;
        break;

      case FETCH_INVITEES:
        draft.isFetchingInvitees = true;
        draft.inviteesList = [];
        break;
      case FETCH_INVITEES_SUCCESS:
        draft.isFetchingInvitees = false;
        draft.inviteesList = action.payload;
        break;
      case FETCH_INVITEES_FAILURE:
        draft.isFetchingInvitees = false;
        draft.inviteesList = [];
        break;

      case EXPORT_REVIEWS:
        draft.isExporting = true;
        break;
      case EXPORT_REVIEWS_SUCCESS:
        draft.isExporting = false;
        break;
      case EXPORT_REVIEWS_FAILURE:
        draft.isExporting = false;
        break;

      case SET_USER_PATH:
        draft.userActivePath = action.payload;
        break;

      case TOGGLE_TEAM_MODAL:
        draft.teamModal = action.payload;
        break;

      case DELETE_TEAM:
        draft.isDeletingTeam = true;
        break;
      case DELETE_TEAM_SUCCESS:
        draft.isDeletingTeam = false;
        break;
      case DELETE_TEAM_FAILURE:
        draft.isDeletingTeam = false;
        break;

      case TOGGLE_SORT_MODAL:
        draft.sortModal = action.payload;
        break;

      case UPDATE_SEQ:
        draft.isUpdatingSeq = true;
        break;
      case UPDATE_SEQ_SUCCESS:
        draft.isUpdatingSeq = false;
        break;
      case UPDATE_SEQ_FAILURE:
        draft.isUpdatingSeq = false;
        break;

      case GET_FEES:
        draft.isFetchingFees = true;
        draft.feeList = [];
        break;
      case GET_FEES_SUCCESS:
        draft.isFetchingFees = false;
        draft.feeList = action.payload;
        break;
      case GET_FEES_FAILURE:
        draft.isFetchingFees = false;
        draft.feeList = [];
        break;

      case UPDATE_FEE:
        draft.isUpdatingFee = true;
        break;
      case UPDATE_FEE_SUCCESS:
        draft.isUpdatingFee = false;
        break;
      case UPDATE_FEE_FAILURE:
        draft.isUpdatingFee = false;
        break;

      case GET_PROFILE:
        draft.isFetchingProfile = true;
        draft.profileList = [];
        break;
      case GET_PROFILE_SUCCESS:
        draft.isFetchingProfile = false;
        draft.profileList = action.payload;
        break;
      case GET_PROFILE_FAILURE:
        draft.isFetchingProfile = false;
        draft.profileList = [];
        break;

      case DELETE_FILE:
        draft.isDeletingFile = true;
        break;
      case DELETE_FILE_SUCCESS:
        draft.isDeletingFile = false;
        break;
      case DELETE_FILE_FAILURE:
        draft.isDeletingFile = false;
        break;

      case DELETE_VIDEO:
        draft.isDeletingVideo = true;
        break;
      case DELETE_VIDEO_SUCCESS:
        draft.isDeletingVideo = false;
        break;
      case DELETE_VIDEO_FAILURE:
        draft.isDeletingVideo = false;
        break;

      case GET_BACK_VIEW:
        draft.isFetchingBackCard = true;
        break;
      case GET_BACK_VIEW_SUCCESS:
        draft.isFetchingBackCard = false;
        break;
      case GET_BACK_VIEW_FAILURE:
        draft.isFetchingBackCard = false;
        break;

      default:
        return state;
    }
  });

export default SlickCareProfilesReducer;
